import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, Type, inject } from '@angular/core';

import { CommercialProposal, FUNDING_ENUM } from '@bytel/checkout';

import { ModalService } from '@base/common/services/modal.service';

import { BasicObject, GenericErrorModal, Message } from '@interfaces/checkout.interface';

import { Subject } from 'rxjs';

import { AppService } from './app.services';

@Injectable({
    providedIn: 'root',
})
export class MessageService {
    public static readonly ERRORS_LEVELS: BasicObject = {
        warning: 'warning',
        error: 'danger',
        info: 'info',
    };
    public dispatchErrors: Subject<Message> = new Subject();

    private _messages: Message[] = [];

    private modalService: ModalService = inject(ModalService);
    private appService: AppService = inject(AppService);

    public constructor() {
        this.init();
    }

    public get errors(): Message[] {
        return this._messages;
    }

    public addError(error: Error, showToUser: boolean = false): void {
        const message: Message = {
            message: error.message,
            level: MessageService.ERRORS_LEVELS.warning,
        };
        this.addMessage(message, showToUser);
    }

    public addMessage(message: Message, showToUser: boolean = false): void {
        this.dispatchErrors.next({
            ...message,
            showToUser,
        });
    }

    public addHttpError(http: HttpErrorResponse): void {
        const message: Message = {
            message: http.error.error_description,
            level: MessageService.ERRORS_LEVELS.warning,
        };

        this.addMessage(message, true);
    }

    public openModal<T extends GenericErrorModal>(
        componentType: Type<T>,
        params: any = null,
        size: string = '',

        outputs?: BasicObject,
    ): void {
        if (this.appService.modalReady) {
            this.modalService.open(componentType, params, { modalSize: size }, outputs);
        } else {
            this.appService.modalSubject.subscribe(() => {
                this.modalService.open(componentType, params, { modalSize: size }, outputs);
            });
        }
    }

    public deleteLevelMessage(level: string): void {
        this._messages.forEach((message: Message, index: number) => {
            if (message.showToUser && message.level === level) {
                this._messages.splice(index, index + 1);
            }
        });
    }

    public resetErrors(): void {
        this._messages = [];
        this.dispatchErrors.next({
            message: '',
            level: '',
            showToUser: false,
        });
    }

    public getModalPaymentTitle(fundingType: string, proposal: CommercialProposal): string {
        let title: string = 'Paiement en';
        if (fundingType === FUNDING_ENUM.COFIDIS) {
            title += ` ${proposal.nbLoan + 1} fois`;
        } else {
            title += ` ${proposal.nbLoan} fois`;
        }

        if (proposal.interestAmount > 0) {
            title += ' avec frais';
        } else {
            title += ' sans frais';
        }
        return title;
    }

    private init(): void {
        this.dispatchErrors.subscribe((error) => {
            if (
                !this._messages.find(
                    (message) =>
                        message.level === error.level &&
                        message.message === error.message &&
                        message.showToUser === error.showToUser,
                )
            ) {
                this._messages.push(error);
            }
        });
    }
}
